import { useCallback, useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { REQUEST_STATE, UseFetchRefs } from "../../dataTypes";
import { setError } from "../../dialog/dialogSlice";
import mapUseFetchRefs from "../../utils/mapUseFetchRefs";
import mergeFetchedTimestampRefAndStateEntities from "../../utils/mergeFetchedTimestampRefAndStateEntities";
import { useValidateUserIsLoggedIn } from "../../utils/useValidateUserIsLoggedIn";
import { selectFormEntities } from "../formSelectors";
import { fetchForm } from "../reducers/fetchForm";

let refs: UseFetchRefs;

const useFetchForm = () => {
  const dispatch = useAppDispatch();
  const result = useValidateUserIsLoggedIn();

  const forms = useAppSelector(selectFormEntities);

  if ((refs as UseFetchRefs | undefined) === undefined) {
    refs = mapUseFetchRefs(forms);
  }

  useEffect(() => {
    refs = mergeFetchedTimestampRefAndStateEntities(refs, mapUseFetchRefs(forms));
  }, [forms]);

  const loadForm = useCallback(
    async (id?: string) => {
      if (result.isError) {
        dispatch(setError({ value: result.errorMessage }));
      } else {
        if (id) {
          const ref = refs[id];

          if (!ref || ref.requestState !== REQUEST_STATE.PENDING) {
            refs[id] = { fetchedTimestamp: Date.now(), requestState: REQUEST_STATE.PENDING };
            await dispatch(fetchForm(id));
          }
        }
      }
    },
    [dispatch, result],
  );

  return loadForm;
};

export default useFetchForm;
